import { createStore, applyMiddleware, compose } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { rootModule, rootSaga } from "store/modules/index";
import createSagaMiddleware from "redux-saga";
import { composeWithDevTools } from "redux-devtools-extension";
import logger from "redux-logger"; // 로거용
import thunk from "redux-thunk";

//사가 미들웨어를 만듦
export const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
    key: "root",
    storage,
    timeout: null,
    blacklist: ["loginReducer", "toastReducer"],
};

const enhancedReducer = persistReducer(persistConfig, rootModule);

//const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

// const store = createStore(enhancedReducer, {}, composeWithDevTools(applyMiddleware(sagaMiddleware, logger, thunk))); // 로거 미들웨어 적용
export const store = createStore(enhancedReducer, composeWithDevTools(applyMiddleware(sagaMiddleware, thunk))); //사가 미들웨어 적용

export default function configureStore() {
    const persistor = persistStore(store);
    sagaMiddleware.run(rootSaga); //루트 사가 실행
    return { store, persistor };
}
